import { StyleProps } from "@shared/primitive-components"

export const root = (props: StyleProps) => ({
  color: props.theme.palette.coal.dark,
})

export const notificationHeading = (props: StyleProps) => ({
  marginTop: props.theme.spacing(7),
  marginBottom: props.theme.spacing(4),
})

export const notificationText = (props: StyleProps) => ({
  marginTop: props.theme.spacing(4),
  marginBottom: props.theme.spacing(7),
})

export const notificationTextWithButton = (props: StyleProps) => ({
  marginRight: props.theme.spacing(2),
})

export const notificationButton = (props: StyleProps) => ({
  height: props.theme.pxToEm(25),
  padding: props.theme.spacing(2),
})

export const notificationFooter = (props: StyleProps) => ({
  marginTop: props.theme.spacing(7),
  marginBottom: props.theme.spacing(7),
})
